var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
function useLocationFetcher({ manageCountriesStateCities, countryCode, stateCode, cityCode, getInfo = false }) {
    const { isLoading: isCountryLoading, data: countries } = useQuery({
        queryKey: ['countries'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return manageCountriesStateCities.findCountries(); }),
        gcTime: Infinity,
        retry: false,
        staleTime: Infinity
    });
    const { isLoading: isStateLoading, data: states } = useQuery({
        queryKey: ['states', countryCode],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return manageCountriesStateCities.findStates(countryCode); }),
        gcTime: Infinity,
        staleTime: Infinity,
        retry: false,
        enabled: !!countryCode
    });
    const { isLoading: isCityLoading, data: cities } = useQuery({
        queryKey: ['cities', countryCode, stateCode],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return manageCountriesStateCities.findCities(countryCode, stateCode); }),
        gcTime: Infinity,
        staleTime: Infinity,
        retry: false,
        enabled: !!countryCode && !!stateCode
    });
    const { isLoading: isLocationInfoLoading, data: locationInfo } = useQuery({
        queryKey: ['locationInfo', countryCode, stateCode, cityCode],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return manageCountriesStateCities.findLocationInfo(countryCode, stateCode, cityCode); }),
        gcTime: Infinity,
        staleTime: Infinity,
        retry: false,
        enabled: !!countryCode && !!stateCode && getInfo
    });
    const getStringLocationInfo = () => {
        var _a, _b, _c;
        return `${((_a = locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.countryData) === null || _a === void 0 ? void 0 : _a.name) || ''} - ${((_b = locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.stateData) === null || _b === void 0 ? void 0 : _b.name) || ''} - ${((_c = locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.cityData) === null || _c === void 0 ? void 0 : _c.name) || ''}`;
    };
    return {
        isCountryLoading,
        countries: countries || [],
        isStateLoading,
        states: states || [],
        isCityLoading,
        cities: cities || [],
        isLocationInfoLoading,
        locationInfo,
        getStringLocationInfo
    };
}
export default useLocationFetcher;
